import React, { useEffect, useState } from "react";
import { Col, Container, Row, Stack, Nav, Tab, Tabs, Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import TODIS_FORM_GENERAL from "./form/LAIRPORTS/general";
import TODIS_FORM_DESC from "./form/LAIRPORTS/description";
import TODIS_FORM_TENCOMPLIANCE from "./form/GENERAL/airportstencompliance";
import TODIS_FORM_ELEGPROJECT from "./form/GENERAL/airportselegibilityproject";
import TODIS_FORM_INDICATORS from "./form/NSEAPORT/indicators";
import TODIS_FORM_PERFOMANCE_INDICADOR from "./form/GENERAL/perfomanceindicador";
import TODIS_FORM_STATUS from "./form/LAIRPORTS/status";
import { TODIS_FORM_DSC } from "../../components/Forms";
import TODIS_FORM_LIVE_FUND from "./form/LAIRPORTS/lFundingsources";
import TODIS_TECH_DOCU from "./form/LAIRPORTS/lTechnicalDocumentation";
import TODIS_TIMELINE from "./form/GENERAL/lTimeline";
import "react-datepicker/dist/react-datepicker.css";
import { BsExclamationCircleFill } from "react-icons/bs";
import TODIS_FORM_OTHER_AIRPORTP from "./form/LAIRPORTS/other";
import { loadModules } from 'esri-loader';

const TODIS_FORM_LAIRPORT = ({ errors, touched, status, setFieldValue, values }) => {

    const [statusTabDisabled, setStatusTabDisabled] = useState(true)

    useEffect(() => {
        try {
            const [Query, query] = loadModules(["esri/rest/support/Query", "esri/rest/query"]);

            let queryUrl = "https://todis.transport-community.org/server/rest/services/Transport_services_parameters/FeatureServer/11";

            let queryObject = new Query();
            queryObject.where = `live_airports_proj_id=${values.liveAirportsProjId}`;
            queryObject.returnGeometry = false;
            queryObject.outFields = "*";

            const results = query.executeQueryJSON(queryUrl, queryObject);

            if (results.features.length > 0) {
                setStatusTabDisabled(false);
            }
        } catch (error) {
            console.log("Something went wrong", error);
        }

    })
    const generalTooltip = (
        <Tooltip id="general-tooltip">
            General data
        </Tooltip>
    );

    const descriptionTooltip = (
        <Tooltip id="description-tooltip">
            Project description
        </Tooltip>
    )

    const statusTooltip = (
        <Tooltip id="status-tooltip">
            Project implementation status
        </Tooltip>
    )

    const tentIndicatorsTooltip = (
        <Tooltip id="tent-indicators-tooltip">
            The TEN-T indicators the project will be addressing
        </Tooltip>
    )

    const tentComplianceTooltip = (
        <Tooltip id="tent-compliance-tooltip">
            Current compliance of the airport section the project is related to
        </Tooltip>
    )

    const perfIndicatorsTooltip = (
        <Tooltip id="perfIndicators-tooltip">
            Project's compliance indicators
        </Tooltip >
    )

    const fundSourcesTooltip = (
        <Tooltip id="fundSources-tooltip">
            Project's funding sources
        </Tooltip>
    )

    const techDocuTooltip = (
        <Tooltip id="techDocu-tooltip">
            Project's technical documentation
        </Tooltip>
    )

    const otherTootltip = (
        <Tooltip id="other-tooltip">
            Other parameters related data
        </Tooltip>
    );
    return (
        <Tabs defaultActiveKey="General" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">
            <Tab eventKey="General" title={
                <OverlayTrigger placement="top" overlay={generalTooltip}>
                    <div>General</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_GENERAL errors={errors} touched={touched} disabled={status} />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="remarks" label="Remarks" name="remarks" disabled={status} />
                            {errors.remarks && touched.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="Description" title={
                <OverlayTrigger placement="top" overlay={descriptionTooltip}>
                    <div>Description</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_DESC errors={errors} touched={touched} disabled={status} TypeForm="airportsLivePmDescDTO" setFieldValue={setFieldValue} values={values} />
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="lStatus" title={
                <OverlayTrigger placement="top" overlay={statusTooltip}>
                    <div>Status</div>
                </OverlayTrigger>
            }>
                <TODIS_FORM_STATUS errors={errors} touched={touched} disabled={status} TypeForm="airportsLivePmStatusDTO" setFieldValue={setFieldValue} values={values} />
            </Tab>
            <Tab eventKey="lFund" title={
                <OverlayTrigger placement="top" overlay={fundSourcesTooltip}>
                    <div>Funding sources</div>
                </OverlayTrigger>
            }>
                <TODIS_FORM_LIVE_FUND errors={errors} touched={touched} disabled={status} TypeForm="airportsLivePmStatusDTO" setFieldValue={setFieldValue} values={values} />
            </Tab>
            <Tab eventKey="lTechDocu" title={
                <OverlayTrigger placement="top" overlay={techDocuTooltip}>
                    <div>Technical documentation</div>
                </OverlayTrigger>
            }>
                <TODIS_TECH_DOCU errors={errors} touched={touched} disabled={status} TypeForm="airportsLivePmStatusDTO" setFieldValue={setFieldValue} values={values} />
            </Tab>
            <Tab eventKey="lTimeline" title="Timeline">
                <TODIS_TIMELINE errors={errors} touched={touched} disabled={status} TypeForm="airportsLivePmStatusDTO" setFieldValue={setFieldValue} values={values} />
            </Tab>
            <Tab eventKey="lElegibilityProject" title={
                <OverlayTrigger placement="bottom" overlay={tentIndicatorsTooltip}>
                    <div>Targeted TEN-T indicators</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_ELEGPROJECT errors={errors} touched={touched} disabled={status} TypeForm="airportsLivePmEligiTentDTO" />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="airportsLivePmEligiTentDTO.remarks" label="Remarks" name="airportsLivePmEligiTentDTO.remarks" disabled={status} />
                            {errors.airportsLivePmEligiTentDTO && errors.airportsLivePmEligiTentDTO.remarks && touched.airportsLivePmEligiTentDTO && touched.airportsLivePmEligiTentDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.airportsLivePmEligiTentDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="lTenCompliance" title={
                <OverlayTrigger placement="bottom" overlay={tentComplianceTooltip}>
                    <div>TEN-T compliance of the related Airport</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_TENCOMPLIANCE errors={errors} touched={touched} disabled={status} TypeForm="airportsLivePmTentcompDTO" />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="airportsLivePmTentcompDTO.remarks" label="Remarks" name="airportsLivePmTentcompDTO.remarks" disabled={status} />
                            {errors.airportsLivePmTentcompDTO && errors.airportsLivePmTentcompDTO.remarks && touched.airportsLivePmTentcompDTO && touched.airportsLivePmTentcompDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.airportsLivePmTentcompDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            {/* <Tab eventKey="perfomanceindicador" title="Performance Indicators">
                <Container>
                    <Row>
                        <TODIS_FORM_PERFOMANCE_INDICADOR errors={errors} touched={touched} disabled={status} TypeForm="airportsLivePmPiDTO" Name1="forecastThroughputTraffic" Name2="actualThroughputTraffic" Label1="Traffic Throughput - forecasted" Label2="Traffic Throughput - actual"/>
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="airportsLivePmPiDTO.remarks" label="Remarks" name="airportsLivePmPiDTO.remarks" disabled={status}/>
                            {errors.airportsLivePmPiDTO && errors.airportsLivePmPiDTO.remarks && touched.airportsLivePmPiDTO && touched.airportsLivePmPiDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.airportsLivePmPiDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab> */}

            <Tab eventKey="lIndicators" title={
                <OverlayTrigger placement="bottom" overlay={perfIndicatorsTooltip}>
                    <div>Performance indicators</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_INDICATORS errors={errors} touched={touched} disabled={status} TypeForm="airportsLivePmIndicatorsDTO" />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="airportsLivePmIndicatorsDTO.remarks" label="Remarks" name="airportsLivePmIndicatorsDTO.remarks" disabled={status} />
                            {errors.airportsLivePmIndicatorsDTO && errors.airportsLivePmIndicatorsDTO.remarks && touched.airportsLivePmIndicatorsDTO && touched.airportsLivePmIndicatorsDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.airportsLivePmIndicatorsDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            {statusTabDisabled ? null :
                <Tab eventKey="Other" title={
                    <OverlayTrigger placement="bottom" overlay={otherTootltip}>
                        <div>Others</div>
                    </OverlayTrigger>
                }>
                    <Container>
                        <Row>
                            <TODIS_FORM_OTHER_AIRPORTP errors={errors} touched={touched} disabled={status} TypeForm="airportsLiveOtherDTO" values={values} />
                        </Row>
                    </Container>
                </Tab>
            }
        </Tabs>
    )
}
export default TODIS_FORM_LAIRPORT;